import React from "react";
import icon from "../../assects/icons/icon.svg";
import icon1 from "../../assects/icons/icon1.svg";
import icon3 from "../../assects/icons/icon3.svg";
import icon4 from "../../assects/icons/icon4.svg";

const WhatIdo = () => {
  const services = [
    {
      icon: icon4,
      title: "Front-End",
      bgColor: "#fff4f4",
      description:
        "Modern and mobile-ready website that will help you reach all of your marketing.",
    },
    {
      icon: icon1,
      title: "Back-End ",
      bgColor: "#f2f4ff",
      description:
        "UI/UX focus on the user, frontend focus on the settings of the user, and backend focus on the data.",
    },
    {
      icon: icon,
      title: "Ui/Ux Design",
      bgColor: "#fff1fb",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam euismod volutpat.",
    },
    {
      icon: icon3,
      title: "Manage Website",
      bgColor: "#fff4f4",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam euismod volutpat.",
    },
  ];

  return (
    <>
      <div className="pb-12">
        <h3 className="text-[33px]  font-bold font-robotoSlab pb-5">
          What I do!
        </h3>
        <div className="grid gap-8 grid-cols-1 md:grid-cols-2">
          {services.map((service, i) => (
            <div
              key={i}
              className={`about-box bg-[${service.bgColor}] shadow-md hover:shadow-xl transition-all duration-500`}
            >
              <img
                className="w-10 h-10 object-contain block"
                src={service.icon}
                alt="icon"
              />
              <div className="space-y-2">
                <h3 className=" text-[22px] font-semibold">{service.title}</h3>
                <p className="leading-8 text-gray-lite darkk:text-[#A6A6A6]">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WhatIdo;
